const translation = {
  pagination: {
    labelDisplayedRows: '{from}-{to} de {count}',
    labelRowsPerPage: 'Linhas por Página:',
    firstAriaLabel: 'Primeira Página',
    firstTooltip: 'Primeira Página',
    previousAriaLabel: 'Página Anterior',
    previousTooltip: 'Página Anterior',
    nextAriaLabel: 'Próxima Página',
    nextTooltip: 'Próxima Página',
    lastAriaLabel: 'Última Página',
    lastTooltip: 'Última Página',
    labelRowsSelect: 'linhas',
  },
  body: {
    emptyDataSourceMessage: 'Nenhum Registro a Ser Exibido',
    editRow: {
      deleteText: 'Deseja realmente apagar este registro?',
      cancelTooltip: 'Cancelar',
      saveTooltip: 'Salvar',
    },
    filterRow: {
      filterTooltip: 'Filtro',
    },
  },
  header: {
    actions: 'Ações',
  },
};

export default translation;
